import {
    AddAttachmentDto,
    AddCustomerImpactDto,
    AddWatcherDto,
    AssignRequestDto,
    AttachmentDto,
    CreateIrtDto,
    CustomerImpactDto,
    CxpApiClient,
    EditIrtDto,
    EntityType,
    HashTagDto,
    IAddAttachmentDto,
    IAddCustomerImpactDto,
    IAssignRequestDto,
    ICreateIrtDto,
    ICustomerImpactDto,
    IHashTagDto,
    IUpdateClassificationDto,
    UpdateClassificationDto,
    UserDto
} from "generated/cxp-backend";
import { IGetAttachment, IShareRequest } from "app/models/common/request";
import { API, appInsightsService } from "app/utils/constants";
import { useMutation, useQuery } from "react-query";
import { AppQueryClient } from "./clients/query-client";
import { RequestDto } from "generated/request-backend";

// The local environment has a trailing slash in the API_SERVER_URL, but test and prod do not.
const baseUrl : string = API.API_SERVER_URL.endsWith('/') ? API.API_SERVER_URL.slice(0,-1) : API.API_SERVER_URL;

//#region Queries
export const useGetAttachments = (requestData: IGetAttachment) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return useQuery(
        ['useGetAttachments'],
        async () => {
            if (requestData) {
                return await cxpApi.irtRequest_GetAttachments(requestData.id,requestData.entityType, requestData.portal);
            }
        },
        { cacheTime: 0 }
    );
};
//#endregion
//#region Mutations
export const useShareRequest = (data: IShareRequest) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    const users : UserDto[] = [];
    data.users.map(user => users.push(new UserDto({...user})));

    const attachments : AttachmentDto[] = [];
    data.attachments.map(attachment => attachments.push(new AttachmentDto({...attachment})));

    return cxpApi.irtRequest_UpdateWatcher(new AddWatcherDto({...data, users: users, attachments: attachments}));
};

/**
 * Mutation used to submit updated request from unified dashboard
 */
export const useUpdateRequest = (data: RequestDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    let irtDto = new EditIrtDto(data);
    irtDto.init(data);
    return cxpApi.irtRequest_UpdateIrt(irtDto);
    // return cxpApi.irtRequest_UpdateIrt(new EditIrtDto({
    //     ...data,
    //     // requestedResolutionDate: new Date(data.requestedResolutionDate),
    //     // companyInformation: new CompanyInformationDto({ ...data.companyInformation })
    // }));
};

/**
 * Module: Admin Assign Request
 * Custom hook to assign a user to a request */
export const useAssignRequest = (data: IAssignRequestDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return cxpApi.irtRequest_Assign(new AssignRequestDto(data));
};

/**
 * Module: Create Request
 * Used for creating new requests (e.g., aggregate parent creation) */
export const useCreateRequest = (data: ICreateIrtDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    const requestDto : CreateIrtDto = new CreateIrtDto();
    requestDto.init(data);
    return cxpApi.irtRequest_CreateIrt(requestDto);
};

export const usePostAddCustomer = async (data: IAddCustomerImpactDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return await cxpApi.irtRequest_AddCustomerImpact(new AddCustomerImpactDto(data));
};

export const useAddAttachment = async (data: IAddAttachmentDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return await cxpApi.irtRequest_AddAttachments(new AddAttachmentDto(data));
};

export const useRemoveAttachment = async (id:string, entityId?:string, entityType?:EntityType) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return await cxpApi.irtRequest_DeleteAttachmentById(id, entityId, entityType);
};

export const useUpdateAttachmentClassification = async (data: IUpdateClassificationDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return await cxpApi.irtRequest_UpdateClassification(new UpdateClassificationDto(data));
};

export const usePostAddCustomerTechnicalRequest = () => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    const requestTypeMutation = useMutation((customerImpact: IAddCustomerImpactDto) => cxpApi.irtRequest_AddCustomerImpact(new AddCustomerImpactDto(customerImpact)), {
        onSuccess: () => {
            setTimeout(() => {
                AppQueryClient.invalidateQueries('useNotificationsCount');
            }, 2000);
            AppQueryClient.invalidateQueries('getRequestById');
            AppQueryClient.invalidateQueries('requestQuery');
            appInsightsService.logEvent('usePostAddCustomerReviewRequest was Succesful');
        }
    });
    return requestTypeMutation;
};

export const useRemoveCustomerImpact = async (id: string, data: ICustomerImpactDto) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    return await cxpApi.irtRequest_DeleteCustomerImpact(id, new CustomerImpactDto(data));
};

export const usePostCommentsHashTags = async (id: string, data: IHashTagDto[]) => {
    const cxpApi : CxpApiClient = new CxpApiClient(baseUrl);
    const hashTags : HashTagDto[] = data.map(hashTag => {
        return new HashTagDto(hashTag)
    });
    return await cxpApi.irtRequest_AddHashTags(id, hashTags);
};
//#endregion